import RestApiModel from "@/api/Model/RestApiModel";
import api from '../index';

class Markets extends RestApiModel {
  static list(facilityId) {
    return super.list({
      endpoint: `/facilities/${facilityId}/markets`
    })
  }

  static getResourceEndpoint(facilityId) {
    return `/facility-markets`;
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
}

export default Markets;
